import { Button } from "react-bootstrap"
import {useSortable} from "@dnd-kit/sortable"
import {CSS} from "@dnd-kit/utilities";
import { DragHandlerIcon } from "./dragHandlerIcon";
import stringUtilities from "../../utilities/stringUtilities";
import pointUtilities from "../../utilities/pointUtilities";
export const WorkflowConfigTypeRow = ({ item, onEditClick, onDeleteClick, onCopyClick, id }) => {
    const {attributes, listeners, setNodeRef, transform, transition } = useSortable({id: id});
    const style = {
		transition,
		transform: CSS.Transform.toString(transform)
	}
    return (
        <tr style={style} ref={setNodeRef} {...attributes} {...listeners}>
            <td className='px-0 py-3'><DragHandlerIcon /></td>
            <td>{ item.name }</td>
            <td>{ item.geometryType ?? "Point" }</td>
            <td className='text-center'>{!stringUtilities.isNullOrEmpty(item.iconUrl) ? <img loading="lazy" style={{width: 20}} src={pointUtilities.getBaseSlugForIcons() + item.iconUrl} /> : "" }</td>
            <td className='text-center'>{ item.allowPhotos ? <i className='fi-check text-success'></i> : <i className='fi-x text-danger'></i> }</td>
            <td className='text-center'>
                {
                    stringUtilities.isNullOrEmpty(item.color) ? <span className="config-color-display config-color-display-null"></span> : <span className='config-color-display' style={ { backgroundColor: `${ item.color }` } }>&nbsp;</span>
                }
            </td>
            <td className='text-end'>
                <Button className='me-2 px-2' variant='outline-secondary' size="sm" onClick={ () => onEditClick(item) }>
                    <span className='d-flex align-items-center'><i className='fi-edit'></i></span>
                </Button>
                <Button className='me-2 px-2' variant='outline-secondary' size="sm" onClick={ () => onCopyClick() }>
                    <span className='d-flex align-items-center'><i className='fi-folders'></i></span>
                </Button>
                <Button className='px-2' variant='outline-danger' size="sm" onClick={ () => onDeleteClick() }>
                    <span className='d-flex align-items-center'><i className='fi-trash'></i></span>
                </Button>
            </td>
        </tr>
    )
}